import React from "react";
import { Spinner as BootSpinner, SpinnerProps as BootSpinnerProps } from "reactstrap";

interface SpinnerProps {
    inline?: boolean;
    size?: "sm" | "3x";
    color?: string;
}

export const Spinner = ({ inline, size, color }: SpinnerProps) => {
    const props: BootSpinnerProps = {
        color: color == null ? "primary" : color,
        type: "border",
        size: size === "3x" ? undefined : "sm",
    };
    let Wrap: React.ElementType = "div";
    if (inline != null && inline) {
        Wrap = "span";
    }
    return (
        <Wrap className="wa-spinner">
            <BootSpinner {...props} />
            <span className="visually-hidden">Loading...</span>
        </Wrap>
    );
};
